const ADD_ACCOUNTS_LIST = 'app/Workspace/Admin/Accounts/ADD_ACCOUNTS_LIST';
const ADD_ACCOUNT = 'app/Workspace/Admin/Accounts/ADD_ACCOUNT';
const SET_TEAM_LIST = 'app/Workspace/Teams/SET_TEAM_LIST';
const ADD_WORKSPACES_LIST = 'app/Workspace/Workspaces/ADD_WORKSPACES_LIST';
const WORKSPACE_LOADING = 'app/Workspace/Workspaces/WORKSPACE_LOADING';
const SET_TEAM_ACCOUNTS = 'app/Workspace/Admin/SET_TEAM_ACCOUNTS';
const ADD_WORKSPACE = 'app/Workspace/Admin/Accounts/ADD_WORKSPACE';
const SET_WORKSPACE_COLLABORATORS = 'app/Workspace/Workspaces/SET_WORKSPACE_COLLABORATORS';
const SET_SELECTED_WORKSPACE = 'app/Workspace/Workspaces/SET_SELECTED_WORKSPACE';

export {
  ADD_ACCOUNT,
  ADD_ACCOUNTS_LIST,
  SET_TEAM_LIST,
  ADD_WORKSPACES_LIST,
  ADD_WORKSPACE,
  WORKSPACE_LOADING,
  SET_TEAM_ACCOUNTS,
  SET_WORKSPACE_COLLABORATORS,
  SET_SELECTED_WORKSPACE,
};
